import { UserEmploymentStatus } from "@ctypes";
import { Translations, i18n } from "@i18n";

export const status: Record<UserEmploymentStatus, string> = {
  [UserEmploymentStatus.Employed]: i18n.t(Translations.EmploymentRouteEmployed),
  [UserEmploymentStatus.Retired]: i18n.t(Translations.EmploymentRouteRetired),
  [UserEmploymentStatus.SelfEmployed]: i18n.t(Translations.EmploymentRouteSelfEmployed),
  [UserEmploymentStatus.Unemployed]: i18n.t(Translations.EmploymentRouteUnemployed),
  [UserEmploymentStatus.HomeMaker]: i18n.t(Translations.EmploymentRouteHomeMaker),
  [UserEmploymentStatus.Student]: i18n.t(Translations.EmploymentRouteStudent),
};
